'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  input {\n    height: calc(100% - 22px);\n    padding-top: 22px;\n  }\n'], ['\n  input {\n    height: calc(100% - 22px);\n    padding-top: 22px;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _nitroTextField = require('../nitro-text-field');

var _nitroTextField2 = _interopRequireDefault(_nitroTextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledInput = exports.StyledInput = (0, _styledComponents2.default)(_nitroTextField2.default)(_templateObject);
StyledInput.displayName = 'StyledInput';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-address-auto-complete/styles.js
// module id = 2880
// module chunks = 4